var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 93,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 92,
  y: 0.631,
  fill: "#F66464",
  fillOpacity: 0.12,
  rx: 46
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F66464",
  d: "M46 25.506a21.125 21.125 0 1 0 21.125 21.125A21.147 21.147 0 0 0 46 25.506m7.65 26.475a1.625 1.625 0 0 1-2.3 2.3L46 48.928l-5.35 5.353a1.627 1.627 0 0 1-2.3-2.3l5.353-5.35-5.353-5.35a1.626 1.626 0 0 1 2.3-2.3L46 44.334l5.35-5.353a1.627 1.627 0 0 1 2.3 2.3l-5.353 5.35z"
})));
export { SvgErrorRounded as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MiIgaGVpZ2h0PSI5MyIgZmlsbD0ibm9uZSI+PHJlY3Qgd2lkdGg9IjkyIiBoZWlnaHQ9IjkyIiB5PSIuNjMxIiBmaWxsPSIjRjY2NDY0IiBmaWxsLW9wYWNpdHk9Ii4xMiIgcng9IjQ2Ii8+PHBhdGggZmlsbD0iI0Y2NjQ2NCIgZD0iTTQ2IDI1LjUwNmEyMS4xMjUgMjEuMTI1IDAgMSAwIDIxLjEyNSAyMS4xMjVBMjEuMTQ3IDIxLjE0NyAwIDAgMCA0NiAyNS41MDZtNy42NSAyNi40NzVhMS42MjUgMS42MjUgMCAwIDEtMi4zIDIuM0w0NiA0OC45MjhsLTUuMzUgNS4zNTNhMS42MjcgMS42MjcgMCAwIDEtMi4zLTIuM2w1LjM1My01LjM1LTUuMzUzLTUuMzVhMS42MjYgMS42MjYgMCAwIDEgMi4zLTIuM0w0NiA0NC4zMzRsNS4zNS01LjM1M2ExLjYyNyAxLjYyNyAwIDAgMSAyLjMgMi4zbC01LjM1MyA1LjM1eiIvPjwvc3ZnPg==";